import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../Common/Loader";
import CommonService from "../../services/common.service";
const Index = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [gameList, setGameList] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    CommonService.userAllGames().then((res) => {
      if (res.status === 200) {
        setGameList(res.data);
        setIsLoading(false);
      }
    });
  }, []);
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Cricket Games</h2>
            </div>
            <div className="tab-content">
              <div className="searchfilter">
                Can't find your game?{" "}
                <a href="signupasagame.html">Create a Game</a> now!
                <div className="custom-searchbox">
                  <Link to={"/"} className="searchicon">
                    <img src="../images/search-icon.png" alt="img" />
                  </Link>
                  <div className="searchbox">
                    <input type="text" className="form-control" />
                    <Link to={"/"} className="closeicon">
                      <img src="../images/close-icon-blue.png" alt="img" />
                    </Link>
                  </div>
                </div>
                <div className="dropdown">
                  <a
                    className="dropdown-toggle"
                    href="#"
                    role="button"
                    id="filter"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src="../images/filter.png" alt="img" />
                  </a>

                  <ul className="dropdown-menu" aria-labelledby="filter">
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 2
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 3
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 4
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 5
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 6
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 7
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 8
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 9
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        Gameweek 10
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="gamelist">
                <ul>
                  {gameList &&
                    gameList.map((item, key) => (
                      <li key={key}>
                        <div className="gamebox">
                          <div className="clubbox">
                            <h4>
                              <Link
                                to={`/dashboard?club_name=${item.string_url}`}
                              >
                                {item?.club_name}
                              </Link>
                            </h4>
                            <span>Club</span>
                            <figure className="club_img">
                              <img
                                src="../images/game-user-img1.png"
                                alt="cricketclub"
                              />
                            </figure>
                          </div>
                          <a
                            href="signupasagame.html"
                            className="badge-success customanch"
                          >
                            Signup
                          </a>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>

              <div className="paginationlink">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="google-ads">
        <div className="container">
          <figure>
            <Link href="">
              <img src="../images/google-ads.jpg" alt="img" />
            </Link>
          </figure>
        </div>
      </div>
    </>
  );
};

export default Index;
